import { SearchResult } from './search-result';

export class SearchResultContainer {
    numResults: number = 0;
    queryTime: number = 0;
    pageSize: number = 0;
    searchResults: Array<SearchResult> = new Array();
    timedOut: boolean;
    canceled: boolean;
    numberOfShards: number;
    usedTokensNumber: number;
    rateLimitEnabled: boolean;
    tokensRemaining: number;
    maxBurst: number;

    constructor(numResults?: number, queryTime?: number, pageSize?: number, searchResults?: Array<SearchResult>) {
        if (numResults) {
            this.numResults = numResults;
        }
        if (queryTime) {
            this.queryTime = queryTime;
        }
        if (pageSize) {
            this.pageSize = pageSize;
        }
        if (searchResults) {
            this.searchResults = searchResults;
        }

    }
}

